define('viewmodels/Weightings_Thresholds/ControlsWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils) {
        var title = 'ControlsWeightings';

        var CWViewModel = {
            activate: activate,
            title: title,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            AssessmentTypeId: ko.observable(),
            AssessmentType: ko.observable(),
            ScreenName: ko.observable(),
            SurveyCategoryListCw: ko.observableArray([]),
            BusinessLevelList: ko.observableArray([]),
            SurveyCategoryTabClickCw: SurveyCategoryTabClickCw,
            RiskLevelTabClick: RiskLevelTabClick,
            SurveyTypeClicked: ko.observable(),
            AreaLeveljstree: ko.observableArray([]),
            SurveyCategoryID: ko.observable(),
            CollapseAllTreeView: CollapseAllTreeView,
            BusinessUnits: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            ControlsWeight: ko.observableArray([]),
            weightingsTableTitle: ko.observable(),
            ToggleNavigationMenu1: ToggleNavigationMenu1,
            ToggleNavigationMenu2: ToggleNavigationMenu2,
            downloadWeightings: downloadWeightings,

            EditBUWeights: EditBUWeights,
            SelectBusinessUnit: ko.observable(),
            uploadDownloadWeightings: uploadDownloadWeightings,
            EditableBusinessUnitName: ko.observable(),
            selectedAreaId: ko.observable(),
            saveWeights: saveWeights,
            WeightingsList: ko.observableArray([]),
            IsDeadNode: ko.observable(0),
            checkCopyOver: checkCopyOver,
            totalWeightList: ko.observableArray([]),
            EditableBusinessunitTotal: ko.observable(0),
            RefreshWeights: RefreshWeights,
            uploadDownloadDetails: ko.observable(),
            uploadWeightingsDocument: uploadWeightingsDocument,
            UploadFileSize: ko.observable(1073741824),
            SelectedOrgLevel: ko.observable(),
            AutoPopulateWeights: AutoPopulateWeights,
            GetTaxonomyLevels: GetTaxonomyLevels,
            TaxonomyLevels: ko.observableArray([]),
            PopulateWeights: PopulateWeights,
            selectedOrgLevelAP: ko.observable(),
            IsLowestLevelSelected: ko.observable(false),
            TaxonomyLevelChanged: TaxonomyLevelChanged,
            GetQuestionTypes: GetQuestionTypes,
            downloadBulkUploadExcel: downloadBulkUploadExcel,
            BulkDownloadWeights: BulkDownloadWeights,
            selectedTaxonomyLevel: ko.observable(),
            BulkuploadWeightingsDocument: BulkuploadWeightingsDocument,
            BulkUploadWeights: BulkUploadWeights,
            QuestionTypes: ko.observableArray([]),
            decimalLimit: ko.observable(5),
            ConfigurePrecision: ConfigurePrecision,
            setPrecisionValues: setPrecisionValues,
            decimalOptions: ko.observableArray(['2', '3', '4', '5']),
            uploadselectedOrganizationLevel: ko.observable(),
            BreadCrumbArray: ko.observable([]),
            screenType: ko.observable(),
            ControlsAccess: ko.observable(false),
            totalValidityFlag: ko.observable(1),
            hasChildNodes: ko.observable(false),
            selectedNodeType: ko.observable(),

            showGlobalConfigurationFlag: ko.observable(false),
            isGlobalFlag: ko.observable(false),
            isAdvancedSettings: ko.observable(false),
            isAdvancedSettingsDUP: ko.observable(false),
            ToggleSettingsMode: ToggleSettingsMode,
            SaveGlobalFlag: ko.observable(false),
            TaxonomyLevelChildrenModel: TaxonomyLevelChildrenModel,
            TaxonomyLevelChildren: ko.observableArray([]),
            selectedTaxonomyLevelChild: ko.observable(),
            selectedTaxonomyLevelChildName: ko.observable(),
            SelectedTaxonomyLevelChildChanged: SelectedTaxonomyLevelChildChanged,
            applyGlobalWeights: applyGlobalWeights,
            AdvanceWeightingslevelSelection: AdvanceWeightingslevelSelection,
            TaxonomyLevelSelectDisable: ko.observable(false),
            ModeSettingsClick: ModeSettingsClick,

            UpperDecimalLimit: ko.observable(100.00000),
            LowerDecimalLimit: ko.observable(0.00000),
            toFixedDown: toFixedDown
        };

        return CWViewModel;

       //#region ----Run Time Events---

        function activate() {
            try {
                var Id = CWViewModel.appsecurity.getParameterByName('atype');
                CWViewModel.AssessmentTypeId(Id);
                CWViewModel.appsecurity.GetAssessmentNames().then(() => {

                    CWViewModel.AssessmentType(CWViewModel.appsecurity.GetAssessmentName(CWViewModel.AssessmentTypeId()));
                    CWViewModel.ScreenName(CWViewModel.AssessmentType() + ' Controls Weightings');
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: activate() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: detached() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                $('#SurveyCategoryTabCw').hide();
                $('#mainLoader').show();
                $("#divNavSwitch2").hide();
                GetSurveyCategoryTabs();
                CWViewModel.EditableBusinessUnitName("Editable BusinessUnit name");
                //GetQuestionTypes();
                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            CWViewModel.ControlsAccess(true);
                        }
                        else {
                            CWViewModel.ControlsAccess(false);
                        }
                    });
                }
                else  if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                    CWViewModel.ControlsAccess(true);
                }
                else {
                    CWViewModel.ControlsAccess(false);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: attached() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----Run Time Methods----

        function SurveyCategoryTabClickCw(data, event, flag) {
            try {
                CWViewModel.SurveyTypeClicked('CDR');
                CWViewModel.SurveyCategoryID(data.SurveyCategoryId());
                CWViewModel.isAdvancedSettings(data.IsAdvancedSettings());
                CWViewModel.isAdvancedSettingsDUP(data.IsAdvancedSettings());
                //GetTaxonomyLevels();
                GetRiskLevelDetails();
                $('#SurveyCategoryTabsDivCw li').removeClass('active');
                $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function RiskLevelTabClick(data, event) {
            try {
                $('#mainLoader').show();
                $('#SurveyCategoryTabCw').hide();
                CWViewModel.SelectedOrgLevel(data.Bulevel());
                $('#RiskAreaUl li').removeClass('active');
                $('#ChildTab_' + data.Bulevel()).addClass('active');
                if (data.Bulevel() == "0")
                    CWViewModel.screenType("W");
                else
                    CWViewModel.screenType("OW");
                InitiateLevelTree();
                $("#spanExpandAllCW").text("Collapse");
                $("#arrowSpanCW").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in RiskLevelTabClick() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----Get Methods----

        function GetSurveyCategoryTabs() {
            try {
                $('#loadingMainControlsDiv').show();
                $.ajax({
                    url: "/api/Configuration/GetControlsSurveyCategoryTabs",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": CWViewModel.AssessmentTypeId(), "ScreenType": "RA" }
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult !== null) {
                                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                                }
                                else {
                                    var mappedTabList = $.map(jsonResult, function (result) {
                                        return new SurveyCategoryModel(result);
                                    });
                                    CWViewModel.SurveyCategoryListCw(mappedTabList);
                                    $('#SurveyCategoryTabCw').tabs();
                                    $('#SurveyCategoryTabCw').tabs('refresh');
                                    $('#SurveyCategoryTabCw').tabs({ active: 0 });
                                    $($('.content li').get(0)).trigger('click');
                                    scrollableTabs();
                                    $('#loadingMainControlsDiv').hide();
                                }
                            }
                            else {
                                $('#loadingMainControlsDiv').hide();
                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function GetRiskLevelDetails() {
            try {
                $.ajax({
                    url: "/api/WeightingsThresholds/getAllBusinessUnitLevels",
                    data: { "type": CWViewModel.AssessmentTypeId(), "Page_Type": "W" },
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in ControlsWeightings.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null && jsonResult.length > 0) {
                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                        }
                        else {
                            var MappedBUModelList = $.map(jsonResult, (result) => {
                                return new BusinessLevelModel(result);
                            });

                            CWViewModel.BusinessLevelList(MappedBUModelList);


                            $('#RaTab').tabs();
                            $('#RaTab').tabs('refresh');
                            $('#RaTab').tabs({ active: 0 });
                            $($('#RaTab li').get(0)).trigger('click');
                        }
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetTaxonomyLevels() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetTaxonomyLevel",
                    type: "GET",
                    data: {
                        "SurveyCategoryID": CWViewModel.SurveyCategoryID(), "Show_Lowest_Level": 0
                    },
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult !== null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                    else {
                        CWViewModel.TaxonomyLevels([]);
                        var MappedTaxonomyLevel = $.map(jsonResult, function (result) {
                            return new TaxonomyModel(result);
                        });
                        CWViewModel.TaxonomyLevels(MappedTaxonomyLevel);
                    }

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyLevels method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyLevels method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetQuestionTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetQuestionTypes",
                    type: "GET",
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                $('#SurveyCategoryTabCw').show();
                $('#mainLoader').hide();
                if (jsonResult !== null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                    else {
                        CWViewModel.QuestionTypes([]);
                        var MappedQuestionTypes = $.map(jsonResult, function (result) {
                            return new QuestionTypeModel(result);
                        });
                        CWViewModel.QuestionTypes(MappedQuestionTypes);
                    }

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionTypes method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionTypes method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetControlsWeight() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/GetControlsWeights",
                    type: "GET",
                    headers: headers,
                    data: { "AssessmentType": CWViewModel.AssessmentTypeId(), "SurveyCategoryId": CWViewModel.SurveyCategoryID().toString(), "AreaId": CWViewModel.selectedAreaId(), "OrgLevel": CWViewModel.SelectedOrgLevel(), "NodeType": CWViewModel.selectedNodeType() }
                })
                    .success((jsonResult, success) => {
                        try {

                            $('#WeightingsTableDiv').show();
                            $('#loadingMainControlsDiv').hide();
                            if (jsonResult !== null) {
                                if (jsonResult.Incident_Description != null) {
                                    logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                                }
                                else {
                                    CWViewModel.BusinessUnits([]);
                                    CWViewModel.AreasOrQuestions([]);
                                    CWViewModel.ControlsWeight([]);

                                    CWViewModel.decimalLimit(jsonResult.precisionObject);

                                    CWViewModel.UpperDecimalLimit(parseInt(CWViewModel.UpperDecimalLimit()).toFixed(CWViewModel.decimalLimit()));
                                    CWViewModel.LowerDecimalLimit(parseInt(CWViewModel.LowerDecimalLimit()).toFixed(CWViewModel.decimalLimit()));

                                    if (jsonResult.TaxonomyLevelChildren.length > 0) {
                                        var mappedTaxonomyLevelChildren = $.map(jsonResult.TaxonomyLevelChildren, (result) => {
                                            return new TaxonomyLevelChildrenModel(result);
                                        });
                                        CWViewModel.TaxonomyLevelChildren([]);
                                        CWViewModel.TaxonomyLevelChildren(mappedTaxonomyLevelChildren);
                                    }

                                    CWViewModel.selectedTaxonomyLevelChild(null);
                                    CWViewModel.selectedTaxonomyLevelChildName(null);
                                    CWViewModel.TaxonomyLevelSelectDisable(false);
                                    for (let i = 0; i < CWViewModel.TaxonomyLevelChildren().length; i++) {
                                        if (CWViewModel.TaxonomyLevelChildren()[i].SelectedFlag() == 1) {
                                            CWViewModel.selectedTaxonomyLevelChild(CWViewModel.TaxonomyLevelChildren()[i].EALId());
                                            CWViewModel.selectedTaxonomyLevelChildName(CWViewModel.TaxonomyLevelChildren()[i].EALName());
                                            CWViewModel.TaxonomyLevelSelectDisable(true);
                                            break;
                                        }
                                    }

                                    if (jsonResult.BUWiseWeightings.length > 0) {
                                        var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                            return new BusinessLevelsModel(result);
                                        });
                                        CWViewModel.BusinessUnits([]);
                                        CWViewModel.BusinessUnits(mappedBusinessUnitData);
                                    }

                                    CWViewModel.totalValidityFlag(1);

                                    for (var i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                                        if (CWViewModel.BusinessUnits()[i].total() == CWViewModel.UpperDecimalLimit() || CWViewModel.BusinessUnits()[i].total() == CWViewModel.LowerDecimalLimit()) {
                                            CWViewModel.totalValidityFlag(1);
                                        }
                                        else {
                                            CWViewModel.totalValidityFlag(0);
                                            break;
                                        }
                                    }

                                    CWViewModel.AreasOrQuestions([]);
                                    if (jsonResult.AreaWiseWeightings.length > 0) {
                                        var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                            return new RiskAreaModel(result);
                                        });
                                        CWViewModel.AreasOrQuestions([]);
                                        CWViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                    }
                                    setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                    CWViewModel.ControlsWeight([]);
                                    if (jsonResult.WeightingsList.length > 0) {
                                        var mappedControlsWeight = $.map(jsonResult.WeightingsList, (result) => {
                                            return new WeightingsModel(result);
                                        });
                                        CWViewModel.ControlsWeight([]);
                                        CWViewModel.ControlsWeight(mappedControlsWeight);
                                    }

                                    let scrollHeight = "27rem";

                                    if ($.fn.DataTable.isDataTable('#WeightingsTable')) {
                                        CWViewModel.AreasOrQuestions([]);
                                        var tableObj = $('#WeightingsTable').DataTable();
                                        tableObj.fixedHeader.disable();
                                        tableObj.destroy();
                                        $('#WeightingsTable tbody tr').remove();
                                        $("#WeightingsTableHeader > th").remove();
                                        $("#WeightingsTableTotal > th").remove();
                                        var htmlHeader = '';
                                        if (CWViewModel.IsDeadNode() === 1) {
                                            htmlHeader += '<th class="site_name Weightings-Fixed-Column">Questions ↓ / Business Units →</th> \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ CWViewModel.EditableBusinessUnitName() + '</th>';
                                        }
                                        else {
                                            htmlHeader += '<th class="site_name Weightings-Fixed-Column" >Areas ↓ / Business Units →</th> \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ CWViewModel.EditableBusinessUnitName() + '</th>';
                                        }
                                        for (var i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                                            htmlHeader += '<th class="site_name header-ellipsis"><div style="display:flex"><label id=' + CWViewModel.BusinessUnits()[i].BUId() + ' title="' + CWViewModel.BusinessUnits()[i].BUName() + '">' + CWViewModel.BusinessUnits()[i].BUName() + '</label> &emsp; <icon class="fa fa-edit float-right float-top" title="Edit Weights" data-bind="click: $root.EditBUWeights"></icon></div></th>';
                                        }

                                        $('#WeightingsTableHeader').html(htmlHeader);
                                        document.getElementById('WeightingsTableHeader').innerHTML = htmlHeader;
                                        ko.cleanNode(document.getElementById('WeightingsTableHeader'));
                                        ko.applyBindings(CWViewModel, document.getElementById("WeightingsTableHeader"));
                                        var htmlFooter = '';
                                        htmlFooter = '<th  class="site_name">Total</th>\
                                        <th class=" text-center heatmap-grey" data-bind="css:{\'heatmap-red\' :($root.EditableBusinessunitTotal()!=$root.UpperDecimalLimit()&&$root.EditableBusinessunitTotal()!=$root.LowerDecimalLimit()),\'heatmap-grey\' :($root.EditableBusinessunitTotal()==$root.UpperDecimalLimit()||$root.EditableBusinessunitTotal()==$root.LowerDecimalLimit())}"> <span data-bind="text:$root.EditableBusinessunitTotal" > </span> <span> % </span></th>';
                                        for (i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                                            if (Number(CWViewModel.BusinessUnits()[i].total()).toFixed(CWViewModel.decimalLimit()) != CWViewModel.UpperDecimalLimit() && Number(CWViewModel.BusinessUnits()[i].total()).toFixed(CWViewModel.decimalLimit()) != CWViewModel.LowerDecimalLimit()) {
                                                htmlFooter += '<th class="heatmap-red text-center " >' + CWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                            }
                                            else {
                                                htmlFooter += '<th class="heatmap-grey text-center" >' + CWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                            }
                                        }
                                        $('#WeightingsTableTotal').append(htmlFooter);
                                        document.getElementById('WeightingsTableTotal').innerHTML = htmlFooter;
                                        ko.cleanNode(document.getElementById('WeightingsTableTotal'));
                                        ko.applyBindings(CWViewModel, document.getElementById("WeightingsTableTotal"));

                                        if (jsonResult.AreaWiseWeightings.length > 0) {
                                            var mappedAandQ = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                                return new RiskAreaModel(result);
                                            });

                                            CWViewModel.AreasOrQuestions(mappedAandQ);
                                            setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                        }
                                        tableObj = $('#WeightingsTable').DataTable(
                                            {
                                                'aoColumnDefs': [{
                                                    'bSortable': false,
                                                    "targets": "_all"
                                                }],
                                                "aaSorting": [],
                                                scrollY: scrollHeight,
                                                scrollX: true,
                                                scrollCollapse: true,
                                                paging: false,
                                                "bInfo": false,
                                                "bAutoWidth": false,
                                                fixedColumns: {
                                                    leftColumns: 1
                                                },
                                                fixedheader: {
                                                    header: true
                                                }

                                            }).draw();


                                    }
                                    else if (!$.fn.DataTable.isDataTable('#WeightingsTable')) {
                                        $('#WeightingsTable').DataTable(
                                            {
                                                'aoColumnDefs': [{
                                                    'bSortable': false,
                                                    "targets": "_all"
                                                }],
                                                "aaSorting": [],
                                                scrollY: scrollHeight,
                                                scrollX: true,
                                                scrollCollapse: true,
                                                paging: false,
                                                "bInfo": false,
                                                "bAutoWidth": false,
                                                fixedColumns: {
                                                    leftColumns: 1
                                                },
                                                fixedheader: {
                                                    header: true
                                                }

                                            });
                                    }
                                }

                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() Success method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function setPrecisionValues(data, event) {
            try {

                try {
                    $.ajax({
                        url: "/api/WeightingsThresholds/setPrecisionValues",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: {
                            "DecimalLimit": document.getElementById("precisionDropDown").value
                        }
                    })
                        .success(function (jsonResult, success) {
                            try {
                                if (jsonResult !== null && jsonResult.substring(0, 3) != "INC") {

                                    logger.logSuccess('Precision Values changed successfully.', 'Success', system.getModuleId(CWViewModel), true);
                                    GetControlsWeight();

                                }
                                else {
                                    logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                                }
                            }
                            catch (e) {
                                let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in ControlsWeightings.js';
                                logger.logMessage(msg);
                            }
                        })
                        .fail(function (error, status) {
                            if (error.status === 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then((option) => {
                                        if (option === "OK")
                                            navigation.unauthorized();
                                    });
                            }
                            else {
                                let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in ControlsWeightings.js';
                                logger.logMessage(msg);
                            }

                        });
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: setPrecisionValues() method in ControlsWeightings.js';
                logger.logMessage(msg);

            }
        }

       //#endregion

       //#region ----Taxonomy Methods----

        function TaxonomyLevelChanged() {
            for (var i = 0; i < CWViewModel.TaxonomyLevels().length; i++) {
                if (CWViewModel.TaxonomyLevels()[i].LevelId() == CWViewModel.selectedTaxonomyLevel()) {

                    if (CWViewModel.TaxonomyLevels()[i].showGlobalFlag() == 1)
                        CWViewModel.showGlobalConfigurationFlag(true);
                    else {
                        CWViewModel.showGlobalConfigurationFlag(false);
                    }

                    if (CWViewModel.TaxonomyLevels()[i].isMaxLevel() == 1) {
                        CWViewModel.IsLowestLevelSelected(true);
                        GetQuestionTypes();
                    }
                    else {
                        CWViewModel.IsLowestLevelSelected(false);
                    }

                    break;
                }
            }
        }

        function SelectedTaxonomyLevelChildChanged() {

            for (var i = 0; i < CWViewModel.TaxonomyLevelChildren().length; i++) {
                if (CWViewModel.TaxonomyLevelChildren()[i].EALId() == CWViewModel.selectedTaxonomyLevelChild()) {
                    CWViewModel.selectedTaxonomyLevelChildName(CWViewModel.TaxonomyLevelChildren()[i].EALName());
                    break;
                }
            }
        }    

        //#endregion

       //#region ----Tree Method----

        function InitiateLevelTree() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/Configuration/GetAllRiskAreasForThreshold",
                    type: "GET",
                    data: { "RiskAreType": CWViewModel.SurveyTypeClicked(), "SurveyCategoryID": CWViewModel.SurveyCategoryID().toString(), "AssessmentTypes": CWViewModel.AssessmentTypeId().toString(), "ScreenType": CWViewModel.screenType() },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                $('#mainLoader').hide();
                $('#SurveyCategoryTabCw').show();
                if (jsonResult !== null) {
                    if (jsonResult.Incident_Description != null) {
                        logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                    else {
                        CWViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        $('#jsTreeAreaLevel').treeview({
                            data: MappedJsTreeList,
                            onNodeSelected: nodeClickEvent
                        });


                        $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                    }
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes !== undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel === 1)
                            return true;
                        return false;

                    }
                );
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function CollapseAllTreeView() {
            if ($('#spanExpandAllCW').text() === "Expand") {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAllCW").text("Collapse");
                $("#arrowSpanCW").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAllCW").text("Expand");
                $("#arrowSpanCW").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        //#endregion

       //#region ----Toggle Navigate Methods----

        function ToggleNavigationMenu1() {
            var chk2 = $('#NavigationToggle2');
            chk2.prop("checked", false);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#WeightingsTableDiv").toggleClass("col-lg-9 col-lg-12");
            $("#WeightingsTableDiv").toggleClass("col-md-9 col-md-12");
            $("#WeightingsTableDiv").toggleClass("col-sm-9 col-sm-12");
            $("#WeightingsTableDiv").toggleClass("col-xs-9 col-xs-12");
            $("#divNavSwitch2").show();
            $("#divjsTree").hide();
            $("#divExpandSwitch").hide();
        }

        function ToggleNavigationMenu2() {
            var chk1 = $('#NavigationToggle1');
            chk1.prop("checked", true);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#WeightingsTableDiv").toggleClass("col-lg-12 col-lg-9");
            $("#WeightingsTableDiv").toggleClass("col-md-12 col-md-9");
            $("#WeightingsTableDiv").toggleClass("col-sm-12 col-sm-9");
            $("#WeightingsTableDiv").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").hide();
            $("#divjsTree").show();
            $("#divExpandSwitch").show();
        }

        function ToggleSettingsMode(data, event) {
            try {

                app.showMessage("<b> By clicking on the Confirm button, Existing weightings will be deleted. If you wish to cancel click on Deny.</b>", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {

                            CWViewModel.isAdvancedSettings(CWViewModel.isAdvancedSettingsDUP());
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/SetAdvanceFlagControls?AssessmentType=" + CWViewModel.AssessmentTypeId() +
                                    "&SurveyCategoryId=" + CWViewModel.SurveyCategoryID().toString() +
                                    "&AdvanceFlag=" + CWViewModel.isAdvancedSettings(),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json',
                            })
                                .success(ajaxSuccess)
                                .fail(ajaxFail);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in ToggleSettingsMode() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Settings selection saved successfully.', 'Success', system.getModuleId(CWViewModel), true);
                        $('#ModeSelectionSettings').modal('hide');
                        GetSurveyCategoryTabs();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in ToggleSettingsMode() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in ToggleSettingsMode() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in ToggleSettingsMode() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

       //#region ----Weights Methods----

        function EditBUWeights(data, event) {
            try {
                var curr = event.currentTarget.parentElement.children[0].id;
                setSelectedBusinessUnit(curr);
                $("div.dataTables_scrollBody").animate({ scrollLeft: 0 }, 800);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: EditBUWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function AutoPopulateWeights(data, event) {
            try {
                $('#AutoPopulatePopup').modal('show');
                if (CWViewModel.TaxonomyLevels() == undefined || CWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: AutoPopulateWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RefreshWeights() {
            try {
                GetControlsWeight();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RefreshWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function saveWeights() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/SaveControlWeightings?AssessmentType=" + CWViewModel.AssessmentTypeId() + "&SurveyCategoryId=" + CWViewModel.SurveyCategoryID().toString() + "&AreaId=" + CWViewModel.selectedAreaId() + "&OrgLevel=" + CWViewModel.SelectedOrgLevel() + "&NodeType=" + CWViewModel.selectedNodeType(), //to save the bu level wieghtings.
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(CWViewModel.WeightingsList(), function (item) {
                        return { BuId: item.BuId(), RiskAreaId: item.RiskAreaId(), WeightingValue: item.WeightingValue() };
                    }))
                })
                    .success(ajaxSuccessControlsWeights)
                    .fail(ajaxFailControlsWeights);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccessControlsWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Controls Weightings are saved successfully.', 'Success', system.getModuleId(CWViewModel), true);
                        GetControlsWeight();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeights() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailControlsWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeights() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeights() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PopulateWeights(data, event) {
            try {

                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> <b> If you do not wish to proceed, please click Deny </b> </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {

                            app.showMessage("Populating weights will delete existing configured weights at this level.Are you sure you would like to proceed?", "Warning", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                                .then(function (option) {
                                    if (option == "Yes") {
                                        var OrgLevel = CWViewModel.selectedOrgLevelAP();
                                        var AreaLevel = CWViewModel.selectedTaxonomyLevel();
                                        var QuestionType = $('#QuestionType').val();
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        $.ajax({
                                            url: "/api/WeightingsThresholds/PopulateWeights?AssessmentType=" + CWViewModel.AssessmentTypeId() + "&SurveyCategoryId=" + CWViewModel.SurveyCategoryID().toString() + "&OrgLevel=" + OrgLevel + "&AreaLevel=" + AreaLevel + "&QuestionType=" + QuestionType,
                                            headers: headers,
                                            type: "POST",
                                            contentType: 'application/json',
                                            dataType: 'json'
                                        })
                                            .success(ajaxSuccessPopulateWeights)
                                            .fail(ajaxFailPopulateWeights);
                                    }

                                });
                        }
                        else {
                            GetControlsWeight();
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in PopulateWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccessPopulateWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Weightings are populated successfully.', 'Success', system.getModuleId(CWViewModel), true);
                        GetControlsWeight();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in PopulateWeights() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailPopulateWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PopulateWeights() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in PopulateWeights() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function applyGlobalWeights(data, event) {
            $('#ConfirmationGlobalPopup').modal('show');
        }

        function AdvanceWeightingslevelSelection(data, event) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/AdvancedControlsWeightingslevelSelection?AssessmentType=" + CWViewModel.AssessmentTypeId() +
                        "&SurveyCategoryId=" + CWViewModel.SurveyCategoryID().toString() +
                        "&AreaId=" + CWViewModel.selectedAreaId() +
                        "&OrgLevel=" + CWViewModel.SelectedOrgLevel() +
                        "&NodeType=" + CWViewModel.selectedNodeType() +
                        "&GlobalFlag=" + CWViewModel.SaveGlobalFlag() +
                        "&SelectedNewLevel=" + CWViewModel.selectedTaxonomyLevelChild() +
                        "&SelectedNewLevelName=" + CWViewModel.selectedTaxonomyLevelChildName(),
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != '0' && jsonResult.substring(0, 3) != "INC") {
                        logger.logSuccess('Configurations are saved successfully.', 'Success', system.getModuleId(CWViewModel), true);
                        GetControlsWeight();
                    }
                    else {
                        logger.logError(jsonResult + ' - Some error occurred while saving. Please contact your Application Administrator.', 'Error', system.getModuleId(CWViewModels), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightsGlobalFlag() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightsGlobalFlag() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightsGlobalFlag() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }


        }

        //#endregion

       //#region ----Upload/Download----

        function BulkDownloadWeights(data, event) {
            try {
                CWViewModel.isGlobalFlag(false);
                $('#BulkDownloadPopup').modal('show');
                if (CWViewModel.TaxonomyLevels() == undefined || CWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: AutoPopulateWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function downloadBulkUploadExcel(data, event) {
            try {

                var GlobalFlag = CWViewModel.isGlobalFlag();
                var QuestionType = $('#QuestionTypeBulkUpload').val();
                QuestionType = (QuestionType == undefined) ? null : QuestionType;
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: data.AssessmentTypeId(), SurveyCategoryId: data.SurveyCategoryID(), AreaId: data.selectedTaxonomyLevel(), OrgLevel: parseInt(CWViewModel.uploadselectedOrganizationLevel()), QuestionType: QuestionType, isGlobalFlag: GlobalFlag
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadBulkUploadExcelTemplate", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | downloadBulkUploadExcel Source | () in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function downloadWeightings(data, event) {
            try {
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: data.AssessmentTypeId(), SurveyCategoryId: data.SurveyCategoryID(), AreaId: data.selectedAreaId(), OrgLevel: CWViewModel.SelectedOrgLevel(), NodeType: CWViewModel.selectedNodeType()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadExcelWeightings", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | downloadWeightings() in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function uploadDownloadWeightings(data, event) {
            try {
                $('#uploadDownloadWeightingsPopup').modal('show');
                document.getElementById('valfactorerror').innerHTML = "";

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: uploadDownloadWeightings() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function uploadWeightingsDocument(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> <b> If you do not wish to proceed, please click Deny </b> </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {

                            var FileList = document.getElementById('FileUploader').files;
                            if (FileList.length > 0) {
                                var FileName = document.getElementById('FileUploader').files[0].name;
                                var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase();
                                if (FileExtension == 'XLSX' || FileExtension == 'XLSM') {
                                    if (FileList[0].size <= 1073741824) {
                                        document.getElementById('valfactorerror').innerHTML = "";
                                        var FormDataObj = new FormData();
                                        FormDataObj.append("File1", FileList[0]);
                                        var request = new XMLHttpRequest();

                                        request.onreadystatechange = function () {
                                            if (request.readyState == 1) {
                                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                                $('#valfactorerror').show();
                                            }
                                            else if (request.readyState == 4) {
                                                if (request.status == 200) {
                                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                                        document.getElementById('FileUploader').value = null;
                                                        if (request.responseText == "2" || request.responseText == "-1") {
                                                            document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(CWViewModel), true);
                                                            $('#valfactorerror').show();
                                                        }
                                                        else {

                                                            document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                                            logger.logSuccess('File Uploaded Successfully ', 'Success', system.getModuleId(CWViewModel), true);
                                                            $('#valfactorerror').show();
                                                            GetControlsWeight();

                                                        }
                                                    }
                                                    else {
                                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                                        logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(CWViewModel), true);
                                                        $('#valfactorerror').show();
                                                        document.getElementById('FileUploader').value = null;
                                                    }
                                                }
                                                else
                                                    ajaxFail(request, "");
                                            }
                                        };

                                        request.upload.addEventListener('progress', function (event) {
                                            document.getElementById('valfactorerror').innerHTML = "Uploading File...";
                                        });
                                        request.withCredentials = true;
                                        request.open('POST', "/api/WeightingsThresholds/UploadWeightingsExcelTemplate?matId=" + CWViewModel.selectedAreaId() + "&ratId=" + CWViewModel.AssessmentTypeId() + "&zatId=" + CWViewModel.SurveyCategoryID().toString() + "&OrgLevel=" + CWViewModel.SelectedOrgLevel() + "&NodeType=" + CWViewModel.selectedNodeType());
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        request.setRequestHeader('Authorization', headers.Authorization);
                                        request.setRequestHeader('RT', headers.RT);
                                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                        request.send(FormDataObj);

                                    }
                                    else {
                                        document.getElementById('FileUploader').value = null;
                                        logger.logError("Upload File Size cannot exceed " + (CWViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.", 'Error', system.getModuleId(CWViewModel), true);
                                    }
                                }
                                else {
                                    document.getElementById('FileUploader').value = null;
                                    logger.logError('Please enter the file in either file in either XLSX or XLSM only.', 'Error', system.getModuleId(CWViewModel), true);
                                }
                            }
                            else {
                                document.getElementById('FileUploader').value = null;
                                logger.logError('Please select a File to Upload', 'Error', system.getModuleId(CWViewModel), true);
                            }
                            function ajaxFail(error, status) {
                                try {
                                    if (error.status == 401) {
                                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                            .then(function (option) {
                                                if (option == "OK")
                                                    router.navigate("survey/SurveyDashBoard", true);
                                            })
                                    }
                                    else {
                                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in uploadWeightingsDocument() method in ControlsWeightings.js';
                                        logger.logMessage(msg);
                                    }
                                } catch (e) {
                                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in uploadWeightingsDocument() method in ControlsWeightings.js';
                                    logger.logMessage(msg);
                                }
                            };
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in uploadWeightingsDocument() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkUploadWeights() {
            try {
                $('#uploadBulkWeightingsPopup').modal('show');
                document.getElementById('valfactorerrorbulkupload').innerHTML = "";
                if (CWViewModel.TaxonomyLevels() == undefined || CWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: uploadWeightingsDocument() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }

        }

        function BulkuploadWeightingsDocument(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> <b> If you do not wish to proceed, please click Deny </b> </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {
                            var FileList = document.getElementById('FileUploaderBulkUpload').files;
                            if (FileList.length > 0) {
                                var FileName = document.getElementById('FileUploaderBulkUpload').files[0].name;
                                var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase();
                                if (FileExtension == 'XLSX' || FileExtension == 'XLSM') {
                                    if (FileList[0].size <= 1073741824) {
                                        document.getElementById('valfactorerrorbulkupload').innerHTML = "";
                                        var FormDataObj = new FormData();
                                        FormDataObj.append("File1", FileList[0]);
                                        var request = new XMLHttpRequest();

                                        request.onreadystatechange = function () {
                                            if (request.readyState == 1) {
                                                document.getElementById('valfactorerrorbulkupload').innerHTML = "Initializing File Upload...";
                                                $('#valfactorerrorbulkupload').show();
                                            }
                                            else if (request.readyState == 4) {
                                                if (request.status == 200) {
                                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                        var DocName = document.getElementById('FileUploaderBulkUpload').files[0].name;
                                                        document.getElementById('FileUploaderBulkUpload').value = null;
                                                        if (request.responseText == "2" || request.responseText == "-1") {
                                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "Error in file upload";
                                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(CWViewModel), true);
                                                            $('#valfactorerrorbulkupload').show();
                                                        }
                                                        else {

                                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "The file has been uploaded successfully.";
                                                            logger.logSuccess('Sheet uploaded successfully ', 'Success', system.getModuleId(CWViewModel), true);
                                                            $('#valfactorerrorbulkupload').show();
                                                            GetControlsWeight();

                                                        }
                                                    }
                                                    else {
                                                        document.getElementById('valfactorerrorbulkupload').innerHTML = "The file could not be uploaded.";
                                                        logger.logError('Some Error Occured while Uploading Document.', 'Error', system.getModuleId(CWViewModel), true);
                                                        $('#valfactorerrorbulkupload').show();
                                                        document.getElementById('FileUploader').value = null;
                                                    }
                                                }
                                                else
                                                    ajaxFail(request, "");
                                            }
                                        };

                                        request.upload.addEventListener('progress', function (event) {
                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "Uploading File...";
                                        });
                                        request.withCredentials = true;
                                        request.open('POST', "/api/WeightingsThresholds/UploadBulkWeightingsExcelTemplate?eblid=" + parseInt(CWViewModel.uploadselectedOrganizationLevel()) + "&ratId=" + CWViewModel.AssessmentTypeId() + "&zatId=" + CWViewModel.SurveyCategoryID().toString() + "&ealid=" + CWViewModel.selectedTaxonomyLevel());
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        request.setRequestHeader('Authorization', headers.Authorization);
                                        request.setRequestHeader('RT', headers.RT);
                                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                        request.send(FormDataObj);

                                    }
                                    else {
                                        document.getElementById('FileUploaderBulkUpload').value = null;
                                        logger.logError("Upload File Size cannot exceed " + (CWViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.", 'Error', system.getModuleId(CWViewModel), true);
                                    }
                                }
                                else {
                                    document.getElementById('FileUploaderBulkUpload').value = null;
                                    logger.logError('Please enter the file in either file in either XLSX or XLSM only.', 'Error', system.getModuleId(CWViewModel), true);
                                }
                            }
                            else {
                                document.getElementById('FileUploaderBulkUpload').value = null;
                                logger.logError('Please select a File to Upload', 'Error', system.getModuleId(CWViewModel), true);
                            }
                            function ajaxFail(error, status) {
                                try {
                                    if (error.status == 401) {
                                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                            .then(function (option) {
                                                if (option == "OK")
                                                    router.navigate("survey/SurveyDashBoard", true);
                                            })
                                    }
                                    else {
                                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in BulkuploadWeightingsDocument() method in ControlsWeightings.js';
                                        logger.logMessage(msg);
                                    }
                                } catch (e) {
                                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in BulkuploadWeightingsDocument() method in ControlsWeightings.js';
                                    logger.logMessage(msg);
                                }
                            };
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in BulkuploadWeightingsDocument() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----Set Methods----

        function setSelectedBusinessUnit(id) {
            try {
                for (var i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                    if (CWViewModel.BusinessUnits()[i].BUId() == id) {
                        CWViewModel.SelectBusinessUnit(CWViewModel.BusinessUnits()[i]);
                        break;
                    }
                }
                CWViewModel.EditableBusinessUnitName(CWViewModel.SelectBusinessUnit().BUName());
                CWViewModel.EditableBusinessunitTotal(parseInt(CWViewModel.SelectBusinessUnit().total()).toFixed(CWViewModel.decimalLimit()));
                for (i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                    CWViewModel.AreasOrQuestions()[i].selectedBuWeight(CWViewModel.SelectBusinessUnit().BUWeightings[i].WeightingValue());
                    CWViewModel.AreasOrQuestions()[i].Applicability(CWViewModel.SelectBusinessUnit().BUWeightings[i].Applicability());
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: setSelectedBusinessUnit() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }

        }

        //#endregion

       //#region ----Copyover----

        function checkCopyOver() {

            app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please click Deny </b>", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        if (CWViewModel.EditableBusinessunitTotal() != CWViewModel.UpperDecimalLimit()) {
                            logger.logError('The total for weightings should be 100% ', 'Error', system.getModuleId(CWViewModel), true);
                        }
                        else {
                            CWViewModel.WeightingsList([]);
                            app.showMessage("Would you like to copy over same weights to all other entities?", "Save/Copy Over", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                                .then(function (option) {
                                    if (option == 'Yes') {
                                        for (var j = 0; j < CWViewModel.BusinessUnits().length; j++) {
                                            for (var i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                                                CWViewModel.WeightingsList.push(new WeightingsModel({ BuId: CWViewModel.BusinessUnits()[j].BUId(), RiskAreaId: CWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: CWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                            }
                                        }
                                        saveWeights();
                                    }
                                    else {
                                        for (i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                                            CWViewModel.WeightingsList.push(new WeightingsModel({ BuId: CWViewModel.SelectBusinessUnit().BUId(), RiskAreaId: CWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: CWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                        }
                                        saveWeights();
                                    }
                                });
                        }

                    }

                    else {
                        GetControlsWeight();
                    }
                });
        }      

        //#endregion

       //#region ----ConfigurePrecision()----

        function ConfigurePrecision(data, event) {
            try {
                $('#ConfigurePrecisionPopUp').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConfigurePrecision() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----Click Events----

        function nodeClickEvent(event, node) {
            try {
                $('#WeightingsTableDiv').hide();
                $('#loadingMainControlsDiv').show();
                CWViewModel.selectedAreaId(node.id);
                CWViewModel.selectedNodeType(node.RA_Type());
                CWViewModel.weightingsTableTitle(node.text);
                CWViewModel.IsDeadNode(node.dead_node);
                GetControlsWeight();

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }   

        function ModeSettingsClick(data, event) {
            CWViewModel.isAdvancedSettingsDUP(CWViewModel.isAdvancedSettings());
            $('#ModeSelectionSettings').modal('show');
        }

        //#endregion

       //#region ----Models----

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.BUWeightings.length; ++p) {
                        total += Number(Number(self.BUWeightings[p].WeightingValue()));
                    }
                    return total.toFixed(CWViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function QuestionTypeModel(item) {
            try {
                var self = this;
                self.QuestionType = ko.observable(item.QuestionType);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: QuestionTypeModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RiskAreaModel(item) {
            try {
                var self = this;
                if (item.QuestionType == null) {
                    self.QuestionType = '';
                }
                else
                    self.QuestionType = item.QuestionType;
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.selectedBuWeight = ko.observable(0);
                self.selectedBuWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && Number(newVal) >= Number(CWViewModel.LowerDecimalLimit()) && Number(newVal) <= Number(CWViewModel.UpperDecimalLimit())) {
                        var total = 0;
                        for (var i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                            total += Number(Number(CWViewModel.AreasOrQuestions()[i].selectedBuWeight()));
                        }
                        CWViewModel.EditableBusinessunitTotal(total.toFixed(CWViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (Number(newVal) < Number(CWViewModel.LowerDecimalLimit()) || Number(newVal) > Number(CWViewModel.UpperDecimalLimit()))) {
                        this.selectedBuWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(CWViewModel), true);
                    }
                    else {
                        this.selectedBuWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                }, this);

                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.LevelId = ko.observable(item.LevelId);
                self.LevelName = ko.observable(item.LevelName);
                self.isMaxLevel = ko.observable(item.isMaxLevel);
                self.showGlobalFlag = ko.observable(item.showGlobalFlag);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
                self.IsAdvancedSettings = ko.observable(item.IsAdvancedSettings);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyLevelChildrenModel(item) {
            try {
                var self = this;
                self.EALId = ko.observable(item.EALId);
                self.EALName = ko.observable(item.EALName);
                self.EALLevel = ko.observable(item.EALLevel);
                self.EALDisplayName = ko.observable(item.EalDisplayName);
                self.SelectedFlag = ko.observable(item.SelectedFlag);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyLevelChildrenModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (CWViewModel.AreaLeveljstree()[self.id].length > 0 && item.DeadNode == 0) {
                self.nodes = $.map(CWViewModel.AreaLeveljstree()[self.id], (result) => {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: true };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);

        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.BuLId).text());
                self.BlName = ko.observable($('<div/>').html(item.BuLevelName).text());
                self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
            } catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

       //#region ----toFixedDown()----

        function toFixedDown(number, digits) {
            var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
                m = number.toString().match(re);
            return m ? parseFloat(m[1]) : number.valueOf();
        };

        //#endregion

    });

